import {
  Button,
  Checkbox,
  CircularProgress,
  Tooltip,
  TextField,
  Typography,
  Grid,
  Chip,
} from "@material-ui/core";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  KeyboardArrowDown,
  KeyboardArrowRight,
} from "@material-ui/icons";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { globalStyles } from "../../assets/globalStyles";
import {
  setKenngroesseWertTemp,
  setIsChangedKenngroesse,
  selectFilteredKenngroessenOfGroup,
  selectKenngroesseWertTemp,
  selectKennegroesse,
  selectKenngroesseLoading,
  setSelectedGroups,
  setOpenGroups,
  setKenngroesseSelectInputValue,
  selectopenGroups,
  selectSelectedGroups,
  selectKenngroesseSelectInputValue,
} from "./kenngroesseSlice";

export default function KenngroesseFilter(props: {
  name: string;
}): ReactElement {
  const dispatch = useAppDispatch();
  const classes = {
    ...globalStyles(),
  };

  const name = props.name;

  const kenngroesseLoading = useAppSelector(selectKenngroesseLoading);
  const kenngroesseSelectInputValue = useAppSelector(selectKenngroesseSelectInputValue);
  const openGroups = useAppSelector(selectopenGroups);
  const selectedGroups = useAppSelector(selectSelectedGroups);
  const kenngroesse = useAppSelector(selectKennegroesse);
  const aktuellerWertTemp = useAppSelector(selectKenngroesseWertTemp);

  function kenngroesseOptionSelection(optionName: string): boolean {
    let returnValue = false;
    aktuellerWertTemp.forEach((x) => {
      const aktuellerOptionWert = x.klasse + x.feldname;
      if (name == "pqIndex") {
        if (optionName == aktuellerOptionWert && x.pqIndex) {
          returnValue = true;
        }
      } else {
        if (optionName == aktuellerOptionWert && x.korrelation) {
          returnValue = true;
        }
      }
    });
    return returnValue;
  }

  function kenngroesseOptionLabel(optionName: string) {
    const currentMessstelle = kenngroesse.find(
      (x) => x.klasse + x.feldname == optionName
    );
    if (currentMessstelle) {
      if (
        currentMessstelle.feldname == "f" &&
        currentMessstelle.klasse == "c10s"
      ) {
        return (
          "10 Sekunden " +
          currentMessstelle.beschreibung +
          " (" +
          currentMessstelle.feldname +
          ")"
        );
      } else if (
        currentMessstelle.feldname == "f" &&
        currentMessstelle.klasse == "c10m"
      ) {
        return (
          "10 Minuten " +
          currentMessstelle.beschreibung +
          " (" +
          currentMessstelle.feldname +
          ")"
        );
      } else {
        return (
          currentMessstelle.beschreibung +
          " (" +
          currentMessstelle.feldname +
          ")"
        );
      }
    }
    return "";
  }

  return (
    <div>
      <Grid item md={12} style={{ marginBottom: "20px" }} />
      <Grid item md={12} style={{ textAlign: "left" }}>
        <Typography color="primary">Kenngrößenauswahl</Typography>
        <Autocomplete
          id="select-kenngroesse"
          limitTags={1}
          // getLimitTagsText={() => "..."}
          multiple
          filterOptions={
            createFilterOptions({
              stringify: option => option.feldname + option.unterkategorie + option.beschreibung
            })
          }
          disableCloseOnSelect
          noOptionsText={
            <React.Fragment>
              {kenngroesseLoading ? (
                <CircularProgress style={{ padding: "5px" }} />
              ) : (
                "Keine Kenngröße"
              )}
            </React.Fragment>
          }
          value={aktuellerWertTemp}
          onChange={(_, newValue) => {
            dispatch(setKenngroesseWertTemp(newValue));
            dispatch(setIsChangedKenngroesse(true));
            dispatch(
              setSelectedGroups(
                newValue
                  .filter((x) => {
                    const allKenngroesseForThisKat = kenngroesse.filter(
                      (kr) =>
                      kr.unterkategorie == x.unterkategorie
                    ).length;
                    const selectedKenngroesseForThisKat = newValue.filter(
                      (kr) =>
                      kr.unterkategorie == x.unterkategorie
                    ).length;
                    return (
                      allKenngroesseForThisKat == selectedKenngroesseForThisKat
                    );
                  })
                  .map(
                    (x) =>
                      x.unterkategorie as string
                  )
              )
            );
          }}
          onClose={() => {
            dispatch(setKenngroesseSelectInputValue(""));
          }}
          inputValue={kenngroesseSelectInputValue}
          onInputChange={(_, newInputValue, reason) => {
            if (reason == "reset") return;
            dispatch(setKenngroesseSelectInputValue(newInputValue));
          }}
          options={ kenngroesse }
          groupBy={(option) => {
            const groupingName = option.unterkategorie + ""
            return groupingName;
          }}
          renderGroup={(params) => {
            return kenngroesse.every((x) => x.klasse + x.feldname != null) ? (
              <React.Fragment>
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="small" />}
                  checkedIcon={<CheckBox fontSize="small" />}
                  style={{ marginRight: -10 }}
                  checked={selectedGroups.includes(params.group)}
                  indeterminate={
                    !selectedGroups.includes(params.group) &&
                    aktuellerWertTemp.some(
                      (k) => k.unterkategorie == params.group
                    )
                  }
                  onChange={() => {
                    if (selectedGroups.includes(params.group)) {
                      dispatch(
                        setSelectedGroups(
                          selectedGroups.filter((x) => x != params.group)
                        )
                      );
                      dispatch(
                        selectFilteredKenngroessenOfGroup({
                          groups: selectedGroups.filter(
                            (x) => x != params.group
                          ),
                          filter: kenngroesseSelectInputValue,
                        })
                      );
                      dispatch(setIsChangedKenngroesse(true));
                    } else {
                      dispatch(
                        setSelectedGroups(selectedGroups.concat([params.group]))
                      );
                      dispatch(
                        selectFilteredKenngroessenOfGroup({
                          groups: selectedGroups.concat([params.group]),
                          filter: kenngroesseSelectInputValue,
                        })
                      );
                      dispatch(setIsChangedKenngroesse(true));
                    }
                  }}
                />
                <Button
                  style={{
                    fontWeight: "bold",
                    textTransform: "none",
                    fontSize: "medium",
                  }}
                  onClick={() =>
                    openGroups.includes(params.group)
                      ? dispatch(
                          setOpenGroups(
                            openGroups.filter((x) => x != params.group)
                          )
                        )
                      : dispatch(
                          setOpenGroups(openGroups.concat([params.group]))
                        )
                  }
                >
                  {openGroups.includes(params.group) ? (
                    <KeyboardArrowDown style={{ marginRight: 10 }} />
                  ) : (
                    <KeyboardArrowRight style={{ marginRight: 10 }} />
                  )}
                  {params.group}
                </Button>
                {openGroups.includes(params.group) ? params.children : ""}
                <br />
              </React.Fragment>
            ) : (
              params.children
            );
          }}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={<CheckBoxOutlineBlank fontSize="small" />}
                checkedIcon={<CheckBox fontSize="small" />}
                style={{
                  marginLeft: 12,
                  marginRight: 12,
                  paddingTop: 1,
                  paddingBottom: 1,
                }}
                checked={selected}
              />
              {option.beschreibung +
                " (" +
                option.feldname +
                ")"}
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Kenngröße"
              variant="outlined"
              classes={{ root: classes.textFieldRoot }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {
                      <div>
                        <Tooltip title="Alle Kenngrößen selektieren">
                          <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            disabled={kenngroesseLoading}
                            onClick={() => {
                              dispatch(
                                setSelectedGroups(
                                  kenngroesse
                                    .filter((x) => x.unterkategorie as string)
                                    .map((x) => x.unterkategorie as string)
                                )
                              );
                              dispatch(
                                selectFilteredKenngroessenOfGroup({
                                  groups: null,
                                  filter: kenngroesseSelectInputValue,
                                })
                              );
                              dispatch(setIsChangedKenngroesse(true));
                            }}
                          >
                            <DoneAllIcon />
                            Alle
                          </Button>
                        </Tooltip>
                        {params.InputProps.endAdornment}
                      </div>
                    }
                  </React.Fragment>
                ),
              }}
            />
          )}
          renderTags={(tagValue, getTagProps) => {
            return tagValue.map((option, index) =>
              kenngroesseOptionSelection(option.klasse + option.feldname) ? (
                <Chip
                  {...getTagProps({ index })}
                  label={kenngroesseOptionLabel(option.klasse + option.feldname)}
                />
              ) : (
                ""
              )
            );
          }}
          // ChipProps={{ disabled: true }}
          className={classes.selectEmpty}
        />
      </Grid>
    </div>
  );
}
